module.exports = "../../static/img/posReport.c0f854c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jpg/posReport.png
// module id = kX2I
// module chunks = 1